import axios from 'axios';
import * as types from '../mutation-types';

export default {
	namespaced: true,
	state: {
		medicalreps:[],
		usersFlowers: [],
		usersTree: [],
		employees: 0,
		medicalRepsBrief: []
	},

	actions: {
		fetchAll({ commit }, { nonDeleted, employeeId }){
            return window.axios.get('/employees/medicalreps', {
                params: {
                    nonDeleted, 
					employeeId
                }
            }).then((response) => {
				if (!employeeId) {
					commit(types.STORE_MEDICALREPS, response.data);
				}
                return response.data;
            })
        },

		fetchByFilter({ commit }, { name, regionIds, teamIds }){
			var urlSearchParams = new URLSearchParams();
			if (name !== null) urlSearchParams.append("name", name);
			regionIds.forEach(id => {
                urlSearchParams.append("regionIds", id);
			});
			teamIds.forEach(id => {
                urlSearchParams.append("teamIds", id);
			});
			urlSearchParams.append('nonDeleted', true);
            return window.axios.get('/employees/medicalreps', {
				params:urlSearchParams
			})
			.then(response => {
                return response.data;
            })
		},
		
		create({ commit }, { data }){
			return window.axios.post('/employees/medicalReps', data);
		},

		update({ commit }, { id, data }){
			return window.axios.put(`/employees/medicalReps/${id}`, data);
		},

		delete({ commit }, { id }){
            return window.axios.delete(`/employees/${id}`);
        },

		toggle({ commit }, { id }){
            return window.axios.put(`/employees/${id}/toggle`);
        },

		fetchUserForUserLogin({ commit }) {
			return window.axios.get('/Employees/Direct').then(({ data }) => {
				commit(types.STORE_USERS_FLOWERS, data)
				return data
			})
		},

		fetchUsersTree({ commit }) {
			return window.axios.get('/Employees/tree').then(({ data }) => {
				commit(types.STORE_USER_TREE, data)
				return data
			})
		},

		fetchEmployeeCount({ commit }) {
			return window.axios.get('/Employees/Count').then(({ data }) => {
				return data
			})
		},
		
		// new for line manager
		fetchEmployeeDirectBrief({ commit }, { employeeId, roleId }) {
			return window.axios.get('/Employees/DirectBrief', { params: { employeeId, roleId } }).then(({ data }) => {
				return data
			})
		},

		updateLineManager ({ commit }, { newLineManagerId, employees }) {
			return window.axios.put('/Employees/LineManager', employees, { params: { newLineManagerId } }).then(({ data }) => {
				return data
			})
		},	

		fetchEmployeeLineManager ({ commit }, { EmployeeId }) {
			return window.axios.get('/Employees/EmployeeManagers', { params: { EmployeeId } }).then(({ data }) => {
				return data
			})
		},

		fetchAllBrief({ commit }, { name, regionIds, nonDeleted }) {
			var urlSearchParams = new URLSearchParams();
            var params = { name, nonDeleted }

            Object.keys(params).forEach(param => {
                if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
            });
			if (regionIds) {
				regionIds.forEach(id => {
					urlSearchParams.append("regionIds", id);
				})
			}
			return window.axios.get('/Employees/MedicalReps/Brief', { params: urlSearchParams }).then(({ data }) => {
				if (!regionIds) {
					commit(types.STORE_EMPLOYEE_BRIEF, data)
				}
				return data
			})
		},

		// get employee manager for ibn alhaytham company
		fetchInitEmployeeManager({ commit }, { roleId, regionIds }) {
			var urlSearchParams = new URLSearchParams()
			var params = { roleId }
			Object.keys(params).forEach(param => {
				if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
			});
			if (regionIds) {
				regionIds.forEach(id => {
					urlSearchParams.append('regionIds', id)
				})
			}
			return window.axios.get('/employees/initEmployeeManagers', { params: urlSearchParams }).then(({ data }) => {
				return data
			})
		} 
	},

	mutations: {
		[types.STORE_MEDICALREPS](state, medicalrepsData){
            state.medicalreps = medicalrepsData.sort(function(a, b) { if (a.name < b.name) { 
				return -1
			}; 
			if (a.name > b.name) {
				return 1 
			}; 
			return 0 
		});
		},
		[types.STORE_USERS_FLOWERS](state, usersFlowers) {
			state.usersFlowers = usersFlowers
		},
		[types.STORE_USER_TREE] (state, usersTree) {
			state.usersTree = usersTree
		},

		[types.STORE_EMPLOYEE_BRIEF](state, medicalRepsBrief) {
			state.medicalRepsBrief = medicalRepsBrief.sort(function(a, b) { if (a.name < b.name) { 
				return -1
			}; 
			if (a.name > b.name) {
				return 1 
			}; 
			return 0 
		})
		}
	},

	getters:{
		getMedicalRepById: state => id => state.medicalRepsBrief.find(c => c.id === id),
		getMedicalRepByName: state => name => state.medicalreps.find(c => c.name === name),
	}
}